import React from 'react';
import { useSidebar } from './lib';
import classNames from 'classnames';
import { Link, useNavigate } from 'react-router-dom';
import './Sidebar.scss';
import { RouteGroup } from './components';
import { UserInfo } from '@widgets/UserInfo';
import { useOpenIdContext } from '@entities/OpenIDProvider/OpenIdContext';
import { EAuthorization_Features } from '@shared/api';
import { ReactComponent as BackButton } from '../../../../shared/assets/svgs/BackButton.svg';

export const Sidebar: React.FC = () => {
    const { linksShown, sidebarMouseLeave, sidebarMouseOver, routeGroups } = useSidebar();
    const navigate = useNavigate();
    const { roles } = useOpenIdContext();

    return (
        <nav
            className={classNames('widget-main-layout-sidebar', 'shown')}
            onMouseOver={sidebarMouseOver}
            onMouseLeave={sidebarMouseLeave}
        >
            <div>
                <div className='flex-only'>
                    <Link
                        to='/'
                        className='widget-main-layout-sidebar__logo'
                    >
                        <img
                            src='/logo.png'
                            alt='logo'
                            className='widget-main-layout-sidebar__logo-image'
                        />
                    </Link>
                    <div
                        className='top-back-button'
                        onClick={() => navigate(-1)}
                    >
                        <BackButton />
                    </div>
                </div>
                <div className='dashboard-names-sidebar'>
                    {roles?.includes(EAuthorization_Features.RIA)
                        ? 'User Role: RIA'
                        : roles?.includes(EAuthorization_Features.Client)
                          ? 'User Role: Customer'
                          : roles?.includes(EAuthorization_Features.TradeDesk)
                            ? 'User Role: Trade Desk'
                            : 'User Role: Operation User'}
                </div>
                <div className={classNames('widget-main-layout-sidebar__routes', { linksShown })}>
                    {routeGroups?.map((routeGroup) => {
                        return (
                            <RouteGroup
                                key={routeGroup.path + routeGroup.name}
                                routeGroup={routeGroup}
                            />
                        );
                    })}
                </div>
            </div>

            <div>
                <UserInfo />
            </div>
        </nav>
    );
};
